import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { columnsFunds } from '../../../helpers/columnsFunds';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { TableLayout } from '../../../layout/TableLayout';
import { EditFunds } from './EditFunds.jsx'
import { selectInvestmentFunds } from '../../../../store/investmentFunds/investmentFundsSlice.js'
import { deleteFund } from '../../../helpers/fund';


export const AdminFundsTable = ({ rows, setReloadData }) => {

    const { t } = useTranslation('global');
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [openEdit, setOpenEdit] = useState(false);

    const onEditClick = (e) => {
        dispatch(selectInvestmentFunds(e.row))
        setOpenEdit(true)
    }

    const onDeleteClick = async (e) => {
        await deleteFund(e, t('delete.successMsg'), t('delete.errorMsg'), t('delete.cancelButton'), t('delete.confirmButton'), t('delete.deleteConfirm'))
        setReloadData(prevState => !prevState)
    }

    const onViewClick = async (e) => {
        navigate(`/viewFunds?fund=${e.row.id}&name=${e.row.name}`)
    }

    const columns = columnsFunds(t, onDeleteClick, onEditClick, onViewClick)

    return (
        <>
            <TableLayout
                rows={rows}
                columns={columns}
                title='fundsAdmin'
            />
            {
                openEdit &&
                <EditFunds setHidden={setOpenEdit} setReloadData={setReloadData} />
            }
        </>
    )
}